export interface CpuPanelProps {
  onClose: () => void
}
